module.exports = __webpack_public_path__ + "static/media/iciciLombard.de8f465f.png";